// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Backdrop-module__Backdrop___2cKDA {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  z-index: 100;\n  left: 0;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}", "",{"version":3,"sources":["Backdrop.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,OAAO;EACP,MAAM;EACN,oCAAoC;AACtC","file":"Backdrop.module.css","sourcesContent":[".Backdrop {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  z-index: 100;\n  left: 0;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n}"]}]);
// Exports
exports.locals = {
	"Backdrop": "Backdrop-module__Backdrop___2cKDA"
};
module.exports = exports;
